export default __webpack_public_path__ + "static/media/Life.188e3e16.svg";